import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const MinusCircleFilled = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7 13H17V11H7V13Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default MinusCircleFilled;
